import { render, staticRenderFns } from "./ApplicationApproval.vue?vue&type=template&id=15ad550c&"
import script from "./ApplicationApproval.vue?vue&type=script&lang=js&"
export * from "./ApplicationApproval.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationApproval.vue?vue&type=style&index=0&id=15ad550c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports